import { render, staticRenderFns } from "./editDialogSpyy.vue?vue&type=template&id=52ca4a2f"
import script from "./editDialogSpyy.vue?vue&type=script&lang=ts"
export * from "./editDialogSpyy.vue?vue&type=script&lang=ts"
import style0 from "./editDialogSpyy.vue?vue&type=style&index=0&id=52ca4a2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports